import styled from 'styled-components';

export const ContainerCard = styled.div`
  border: 1px solid #f3f3f3;
  padding: 6px 12px;
  border-radius: 6px;
`;
